import script from "./Speakers.vue?vue&type=script&setup=true&lang=js"
export * from "./Speakers.vue?vue&type=script&setup=true&lang=js"

import "./Speakers.vue?vue&type=style&index=0&id=0f6ed9dc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f6ed9dc"]])

export default __exports__